// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__4q4tu","label":"SetPasswdForm_label__2Cn2j"};